var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuriosity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8002 7.20009C12.7863 7.20009 14.4002 5.5854 14.4002 3.60183C14.4002 1.61478 12.7863 9.15527e-05 10.8002 9.15527e-05C8.81411 9.15527e-05 7.2002 1.61478 7.2002 3.60183C7.2002 5.5854 8.81411 7.20009 10.8002 7.20009Z",
    fill: "#81D4A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20105 10.9364C6.44858 11.1602 6.59109 11.4831 6.59109 11.8207V15.2332C6.59109 15.435 6.75987 15.6001 6.96614 15.6001H14.9996V12.7967C14.9996 12.5913 15.1684 12.4298 15.3747 12.4298C15.581 12.4298 15.7497 12.5913 15.7497 12.7967V15.6001H17.625C17.8312 15.6001 18 15.435 18 15.2332V12.5252C18 9.86864 15.791 7.70741 13.0719 7.70741H9.64022C8.76636 7.70741 7.95626 7.32581 7.4162 6.66533C6.04728 4.99947 4.78712 3.09877 3.66198 1.0146C3.39945 0.526583 2.93439 0.174329 2.38683 0.0495727C1.83551 -0.0751837 1.25794 0.0385646 0.800381 0.361464C0.0240359 0.915529 -0.227245 1.96128 0.22281 2.79054C2.15055 6.36812 4.10454 9.03203 6.20105 10.9364Z",
    fill: "#81D4A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuriosity);
export default __webpack_public_path__ + "static/media/curiosity.ed4218c824db992f438ef0a7826e57f3.svg";
export { ForwardRef as ReactComponent };